<template>
<div>
	<span style="font-size:14px;
	font-family:Microsoft YaHei;
	font-weight:bold;
	color:red;">{{lable}}：</span>
	<VsSelect style="display: inline-block;background:rgba(255,255,255,1);border-radius:3px;"
        :width="width" 
        :classtype="classtype"
        v-model="select.value"
        :loopdata="select.droplist"
        :keys="['CKMC']"
        @click="fnInputSelect"
        @input="fnInputAct"
        @on-enter="fnEnterpressAct"
        @inputserch="fnInputSelect"
        :requiremore="select.requiremore"
        @require="fnInputSelect"
        @on-confirm="fnSelectConfirm">
	</VsSelect>
    </div>
</template>

<script>
export default{
    props:{
        loopdata:{},
        keys:{},
        width:{},
        lable:{},
        classtype:{},
        returnkey:{},
        selectValue:{},
    },
    model: {
        prop: 'selectValue',
        event: 'on-model'
    },
    data(){
        return{
            select:{
                value:'',
                PageNo:'1',
                PageSize:'50',
                requiremore:true,
                droplist:[],
            },
        }
    },
    methods:{
        fnInputAct(){
            this.select.droplist = []
            this.select.requiremore = true
            this.fnSelectConfirm()
            this.$emit('input')
        },
        
        fnInputSelect(){
            this.select.value = ''
            this.$emit('on-model', "")
            if(this.select.requiremore){
                let params = this.$fun.GetUserConstant();
                // console.log('根据账户信息下有权限的' + JSON.stringify(params))
                this.$Api.ErpGetCKByUserInfo(params).then((res)=>{
                    // console.log(res)
                    this.select.droplist = res.data.ck
                    this.select.requiremore = false
                })
            }
        },
        
        fnSelectConfirm(data){
            if(data){
                if(this.returnkey){
                    this.$emit('on-model',data[this.returnkey])
                    this.$emit('on-select',data)
                }else{
                    this.$emit('on-select',data)
                }
            }else{
                this.$emit('on-select',"")
            }
        },
        
        fnEnterpressAct($event){
            this.$emit('on-enter',$event)
        }
    }
}
</script>
